// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Bind{border-radius:8px;box-shadow:0 2px 16px 1px rgba(89,104,143,.06);color:var(--primary);flex-shrink:0;height:100%;max-height:calc(100vh - 64px);overflow-y:auto;right:32px;top:32px;width:420px}.Bind,._99VU{background-color:var(--white);display:flex;flex-direction:column;position:sticky}._99VU{border-bottom:1px solid var(--grey-200);gap:17px;left:0;top:0;width:100%;z-index:9}.lg22{all:unset;box-sizing:border-box;color:currentColor;display:inline;font-family:\"Roboto\",sans-serif!important;font-size:24px;font-style:normal;font-weight:400;line-height:32px;margin:24px 24px 0;overflow:hidden;text-align:center;text-overflow:ellipsis;white-space:nowrap}.Iipr{border-top:1px solid var(--grey-200);margin-top:auto;padding:16px 24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PWAside": "Bind",
	"PWAsideHeader": "_99VU",
	"PWAsideHeaderTitle": "lg22",
	"PWAsideFooter": "Iipr"
};
module.exports = ___CSS_LOADER_EXPORT___;
